/* eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import Booking from '@/components/client//BookingLayout'
import EventLayout from '@/components/client/EventLayout'
import EventPage from '@/components/client/EventPage'
import HallPage from '@/components/client/HallPage'
import ConfrimOrder from "../components/client/ConfrimOrder.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Booking',
      component: Booking
    },
    {
      path: '/event',
      name: 'EventLayout',
      component: EventLayout
    },
    {
      path: '/event/:eventId',
      name: 'EventPage',
      component: EventPage,
      props: true
    },
    {
      path: '/confirm',
      name: 'ConfirmOrder',
      component: ConfrimOrder
    },
    {
      path: '/event-hall/:eventId',
      name: 'HallPage',
      component: HallPage,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js